export { default } from './Minimize';